<template>
  <BaseEmptyState
    title="Não há nenhum roteiro criado"
    subtitle="Você ainda não criou nenhum roteiro. Comece agora criando os pontos de parada."
    button-text="Criar roteiro"
    button-aria-label="Criar novo roteiro"
    secondary-button-text="Upload em massa"
    secondary-button-icon="upload"
    secondary-button-aria-label="Upload em massa de roteiros"
    :show-secondary-button="canCreate"
    :secondary-button-loading="uploading"
    :secondary-button-disabled="uploading"
    :show-button="canCreate"
    @action="handleCreate"
    @secondary-action="handleBulkUpload"
  />
</template>

<script>
import BaseEmptyState from "@/shared/components/BaseEmptyState.vue";

export default {
  name: "ItinerariesEmptyState",
  components: { BaseEmptyState },
  props: {
    canCreate: {
      type: Boolean,
      default: true,
    },
    uploading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleCreate() {
      this.$emit("create-itinerary");
    },
    handleBulkUpload() {
      this.$emit("bulk-upload");
    },
  },
};
</script>
